import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
import { useNavigate, useLocation } from '@reach/router';

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  listBackground: {
    backgroundImage: 'linear-gradient(to right, #1FA2FF, #12D8FA, #A6FFCB)',
  },
  item: {
    marginLeft: '35vw',
    paddingBottom: '5px',
  },
});

const MobileMenu = (props) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const navigate = useNavigate();
  const location = useLocation();

  const handleRoute = (href, external = false) => {
    if (external) {
      // eslint-disable-next-line no-undef
      window.open(href, '_blank');
    } else {
      navigate(href);
    }
  };

  const { direction, tabs } = props;

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown'
      && (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List className={classes.listBackground}>
        {tabs.map((tab) => (
          <div key={tab.name} className={classes.item}>
            <Button
              style={{
                color: '#484848',
                justifyContent: 'end',
              }}
              variant={location.pathname === tab.href ? 'outlined' : 'text'}
              onClick={() => handleRoute(tab.href, tab.external)}
            >
              {tab.name}
            </Button>
          </div>
        ))}
      </List>
    </div>
  );

  return (
    <Grid item xs={2} sm={1}>
      {[direction].map((anchor) => (
        <React.Fragment key={anchor}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(anchor, true)}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </Grid>
  );
};

MobileMenu.defaultProps = {
  direction: 'top',
};

MobileMenu.propTypes = {
  direction: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  // eslint-disable-next-line react/forbid-prop-types
  tabs: PropTypes.array.isRequired,
};

export default MobileMenu;
